<template>
  <div class="sequences-filters">
    <v-btn 
      v-if="advancedSearchActive" 
      rounded
      class="transparent"
      text 
      color="bhRed" 
      @click="clearFilters"
    >
      Clear filters
      <v-icon class="pl-2">bhi-close-circle</v-icon>
    </v-btn>
    <v-btn 
      :color="advancedSearchActive ? 'bhRed': 'accent'" 
      text 
      rounded 
      @click="openAdvancedSearch"
    >
      Advanced search
      <v-icon class="pl-2">bhi-filter</v-icon>
    </v-btn>
    <v-text-field
      :value="value ? value : ''"
      class="bh-input-pill rounded-pill"
      color="accent"
      height="48px"
      width="200px"
      append-icon="bhi-loupe"
      placeholder="Search for Routines"
      filled
      clearable
      hide-details
      @input="onInput('query', $event)"
      @click:clear="clearSearch"
      @click:append="runSearch"
      @keydown.enter="runSearch"
    ></v-text-field>
  </div>
</template>
<script>
import { debounce } from "@/helpers/debounce"
export default {
  name: "SequencesFilters",
  props: {
    value: {
      type: [String, null],
      default: ''
    },
    advancedSearchActive: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    tmpValue: '',
    routinesCountFrom: 0,
    routinesCountTo: 10,
    daysFrom: 0,
    dayTo: 30,
    routinesCount: [0, 10],
    days: [0, 30],
    multipleInputs: [],
  }),
  watch: {
  },
  computed: {
    filtersActive() {
      if (this.$route.query && (this.$route.query.routinesCountFrom || this.$route.query.routinesCountTo || this.$route.query.daysFrom || this.$route.query.dayTo)) return true
      else return false
    }
  },
  created() {
    if (this.value) this.tmpValue = this.value || ''
  },
  methods: {
    clearSearch() {
      this.tmpValue = ''
      this.$emit('search-on:clear')
    },
    runSearch() {
      if (this.tmpValue)
        this.$emit('search-run', this.tmpValue)
    },
    onInput (key, value) {
      if (key == 'query') this.tmpValue =  value ? value.toString() : null
      debounce(() => {
        this.$emit('search-on:input', { key, value })
      },1000, 'SequencesFilters')
    },
    onMultiple (key, value) {
      this.multipleInputs.push({key: key, value: value})
      debounce(() => {
        this.$emit('search-on:multiple', this.multipleInputs)
        this.multipleInputs = []
      },1000, 'SequencesFilters')
    },
    clearFilters() {
      this.routinesCount = [this.routinesCountFrom, this.routinesCountTo]
      this.days = [this.daysFrom, this.dayTo]
      this.tmpValue = ''
      this.multipleInputs = []
      this.$emit('clear-filters')
    },
    openAdvancedSearch() {
      this.$emit('open-advanced-search')
    },
  }
};
</script>
<style lang="scss">
.sequences-filters {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  .v-btn {
    background:$bh-gray--6;
    margin-left: $gutter/2;
    &.active {
      background: $bh-blue !important;
      .v-icon {
        &::before {
          color: $bh-white;
        }
      }
      small {
        color:$bh-white;
      }
    }
    &.transparent {
      background: transparent !important;
    }
    &--disabled {
      opacity: 0.3;
    }
  }
  .range {
    display: flex;
    align-items:center;
    color: $bh-gray;
    font-size: 0.9rem;
    position: relative;
    .v-messages {display: none;}
    & > .v-input {
      width: 200px;
      margin:0 8px;
      background: $bh-white;
      border-radius: $gutter;
      .v-input__slot {
        margin-bottom: 0;
      }
      .v-slider--horizontal {
        margin-left: 12px;
        margin-right: 12px;
      }
      .v-slider__thumb-container {
        cursor: grab;
      }
    }
  }
}
.bh-input-pill {
  margin: 0 8px !important;
  width: 264px;
  height: 48px !important;
  &.v-input--is-disabled {
    opacity: 0.3;
  }
  .v-input__slot {
    align-items: center;
    height: 48px;
    min-height: 0 !important;
    background:$bh-gray--6 !important;

    &::before,
    &::after {
      content: "";
      display: none;
    }

    .v-input__append-inner {
      align-self: center;
      margin-top: 0 !important;
    }

    .v-icon {
      color: $bh-blue;
    }
  }
}
</style>
